// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"7d668cd1","75":"a838a624","116":"2eb9ae87","339":"1ca3afc1","358":"ccc8b8c7","551":"93c86cee","629":"d0483110","640":"bfaecf0b","828":"7ae44d4d"}[chunkId] + ".chunk.js";
};